// ════════════════════════════════════════════════════════════
// Supabase client — ECR
// ════════════════════════════════════════════════════════════
// Client typé avec le schéma `Database` complet.
// Les credentials sont injectées par Cloudflare Pages selon
// l'environnement de déploiement (cf. .env.example).
// ════════════════════════════════════════════════════════════
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

// `.trim() || fallback` (et non `??`) : rattrape aussi la chaîne vide ""
// (un env var défini mais vide produit sinon un apikey="" → erreur Supabase
// "No API key found in request").
const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? '').trim();
const SUPABASE_ANON_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim();

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error(
    '[Supabase] VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY manquants/vides — ' +
      'les requêtes échoueront avec "No API key". Vérifie les variables Cloudflare Pages (Production ET Preview).',
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  SUPABASE_URL || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'ecr-auth',
    },
  },
);
